import { Box } from "@dealer-center/core-components";
import { useNavBarStore } from "../../store";
import { getInitialsFromName } from "./helper";

export const LetteredAvatar = () => {
  const { user } = useNavBarStore();
  const name = user?.name || "?";
  const initials = getInitialsFromName(name);
  return (
    <Box
      sx={{
        bgcolor: "primary.main",
        color: "primary.contrastText",
        width: 32,
        height: 32,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 14,
        fontWeight: 600
      }}
    >
      {initials}
    </Box>
  );
};
